import React from 'react';

const coursesData = [
  {
    id: 1,
    name: 'B.Sc Nursing',
    duration: '4 Years',
    eligibility: '10+2 with PCB (50% Marks)',
    seats: 60,
    fees: '₹85,000/year',
    icon: '🎓',
    description: 'Comprehensive bachelor program covering fundamentals of nursing, anatomy, physiology, and clinical practice.',
  },
  {
    id: 2,
    name: 'Post Basic B.Sc Nursing',
    duration: '2 Years',
    eligibility: 'GNM Diploma + Registration',
    seats: 30,
    fees: '₹75,000/year',
    icon: '📋',
    description: 'Advanced program for registered nurses to upgrade qualifications and specialize in nursing practice.',
  },
  {
    id: 3,
    name: 'M.Sc Nursing',
    duration: '2 Years',
    eligibility: 'B.Sc Nursing with 55% Marks',
    seats: 20,
    fees: '₹1,20,000/year',
    icon: '🎓',
    description: 'Master\'s program with specializations in Medical-Surgical, Pediatric, Psychiatric, and Community Health Nursing.',
  },
  {
    id: 4,
    name: 'GNM',
    duration: '3.5 Years',
    eligibility: '10+2 (Any Stream)',
    seats: 40,
    fees: '₹60,000/year',
    icon: '💉',
    description: 'General Nursing and Midwifery diploma program for entry-level nursing professionals.',
  },
  {
    id: 5,
    name: 'ANM',
    duration: '2 Years',
    eligibility: '10th Pass',
    seats: 50,
    fees: '₹40,000/year',
    icon: '🩺',
    description: 'Auxiliary Nurse Midwifery program focusing on basic nursing and midwifery skills.',
  },
  {
    id: 6,
    name: 'Certificate Courses',
    duration: '6 Months - 1 Year',
    eligibility: '10+2 / Graduate',
    seats: 25,
    fees: '₹25,000/course',
    icon: '📜',
    description: 'Short-term certifications in Critical Care, OT Techniques, Emergency Care, and more.',
  },
];

function Courses() {
  return (
    <section id="courses" className="courses-section">
      <div className="section-container">
        <h2 className="section-title">
          <span className="title-icon">📚</span> Our Courses
        </h2>
        <p className="section-subtitle">
          Choose from our range of UG, PG, Diploma, and Certificate programs
        </p>
        <div className="courses-grid">
          {coursesData.map((course) => (
            <div key={course.id} className="course-card">
              <div className="course-header">
                <span className="course-icon">{course.icon}</span>
                <h3>{course.name}</h3>
              </div>
              <div className="course-details">
                <div className="detail-item">
                  <span className="detail-label">⏱️ Duration</span>
                  <span className="detail-value">{course.duration}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">📝 Eligibility</span>
                  <span className="detail-value">{course.eligibility}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">💺 Seats</span>
                  <span className="detail-value">{course.seats}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">💰 Fees</span>
                  <span className="detail-value">{course.fees}</span>
                </div>
              </div>
              <p className="course-desc">{course.description}</p>
              <button className="btn btn-primary course-btn">Apply Now</button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Courses;